import { DaySlotSchedule } from '../../types'
import { getUTCDate } from '@/utils/getUTCDate'

export class PsyScheduleMapper {
  toDomain(data: DaySlotSchedule) {
    return {
      date: getUTCDate(data?.date),
      slots: data?.schedules?.map(slot => {
        return {
          id: slot.id,
          time: slot.time,
        }
      }),
    }
  }
}

export default new PsyScheduleMapper()
